import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
import { useLeadersContext } from '../state/leaders'

import ModalWHeader from './ModalLeaders'
import { ActivityType } from './activityType'
import { EventWithId } from '../types/Firestore'

interface Props {
  event: EventWithId
}

export default function activityRow({ event }: Props) {
  const { getLeadersById } = useLeadersContext()

  const leaders = getLeadersById(event.leaders)
  const leadersImg = leaders.map((leader) => leader.image)
  leadersImg[Math.floor(Math.random() * leadersImg.length)]

  const randomImg = useRef(leadersImg[Math.floor(Math.random() * leadersImg.length)])
  return (
    <div className='activities-container'>
      <Link to={`/activity/${event.id}`} className='link-activities'>
        <div className='activity-type'>
          <div className='timereg-logo'>
            <ActivityType type={event.type} />
          </div>
        </div>
        <div className='activity'>
          <div className='activity-date'>
            {new Date(event.date).toLocaleDateString('sv-SV', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
            })}
          </div>
          <div className='activity-info'>
            {event.time_start} - {event.time_end} <br />
            {event.location}
          </div>
          <div className='activity-title'>{event.type}</div>
        </div>

        <div className='activities-personel'>
          <img src={randomImg.current || 'https://png.pngtree.com/png-vector/20190307/ourlarge/pngtree-vector-add-user-icon-png-image_762930.jpg'} alt='' />
        </div>
      </Link>
      <ModalWHeader leaders={leaders} date={event.date} />
    </div>
  )
}
